import { render, staticRenderFns } from "./ApiLookup.vue?vue&type=template&id=38973af0&"
import script from "./ApiLookup.vue?vue&type=script&lang=js&"
export * from "./ApiLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports